'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const wrapper = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-VariantDropdown-web-styleswrapper", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL1ZhcmlhbnREcm9wZG93bi9WYXJpYW50RHJvcGRvd24ud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL1ZhcmlhbnREcm9wZG93bi9WYXJpYW50RHJvcGRvd24ud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuaW1wb3J0IHsgekluZGV4IH0gZnJvbSBcIiNjb25zdGFudHNcIjtcblxuZXhwb3J0IGNvbnN0IHdyYXBwZXIgPSBjc3Moe1xuICBwYWRkaW5nOiBcIjhweCAwXCIsXG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHpJbmRleDogekluZGV4LmNhcmRBY3Rpb24sXG59KTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJdUIifQ== */");

exports.wrapper = wrapper;
//# sourceMappingURL=VariantDropdown.web.styles.cjs.map
